module.exports = __webpack_public_path__ + "img/logo.8d806353.png";